import AwesompleteAJAX from '../AwesompleteAJAX'
import $ from 'jquery';

let  autocompleteField;

export default function initialize() {

  autocompleteField = $('[data-autocomplete]');
  autocompleteField.each(function() {
    const awesomeplete = new AwesompleteAJAX(this, {
      autoFirst: true,
      container: (input) => {
        const suggestions = $(input).siblings('.search-box__results').find('.search-box__suggestions').get(0);
        return suggestions;
      },
    });

    this.setAttribute('autocomplete', 'off');
    awesomeplete.ajaxUrl = '/wp-json/techcor/v1/autocomplete/';
  });
}




// WEBPACK FOOTER //
// ./scripts/lib/search/autocomplete.js